import React from 'react';
import ContentLoader from 'react-content-loader';
  function CustomerTabLoader () {
    return (
      <ContentLoader type="instagram" height="300" primaryColor="#cccccc" secondaryColor="#000000" secondaryOpacity="0.3" primaryOpacity="0.1" speed="0.7">
        <rect x="10" y="5" rx="1" ry="1" width="380" height="5" />
        <rect x="10" y="50" rx="1" ry="1" width="380" height="5" />
        <rect x="10" y="100" rx="1" ry="1" width="380" height="5" />
      </ContentLoader>
    )
  }
  function DelayTabLoader () {
    return (
      <ContentLoader type="instagram" height="300" primaryColor="#cccccc" secondaryColor="#000000" secondaryOpacity="0.3" primaryOpacity="0.1" speed="0.7">
        <rect x="10" y="5" rx="1" ry="1" width="380" height="8" />
        <rect x="10" y="50" rx="1" ry="1" width="380" height="8" />
        <rect x="10" y="100" rx="1" ry="1" width="380" height="8" />
      </ContentLoader>
    )
  }
  function KpiLoader () {
    return (
    <ContentLoader type="instagram" height="300" primaryColor="#cccccc" secondaryColor="#000000" secondaryOpacity="0.3" primaryOpacity="0.1" speed="0.7">
      <rect x="10" y="100" rx="1" ry="1" width="380" height="10" />
    </ContentLoader>
    )
  }
  function KpiLoaderSecond () {
    return (
    <ContentLoader type="instagram" height="300" primaryColor="#cccccc" secondaryColor="#000000" secondaryOpacity="0.3" primaryOpacity="0.1" speed="0.7">
      <rect x="10" y="75" rx="1" ry="1" width="380" height="10" />
    </ContentLoader>
    )
  }
export {CustomerTabLoader, DelayTabLoader, KpiLoader, KpiLoaderSecond} 


// WEBPACK FOOTER //
// ./src/util/loader.js